export const ACTIVE_STATUSES = ['ACTIEF', 'GARAGE'];
//# sourceMappingURL=car.js.map